import { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AutoSendRounds from "../components/ETax/AutoSend/AutoSendRounds";
import { getEtaxBreadcrumbLabel } from "../components/ETax/etaxTitle";
import {
  buildDateRangeSearch,
  resolveDateRangeParams,
} from "../components/ETax/dateRangeParams";

export default function ETaxAutoSendPage() {
  // The dashboard opens this page with its range so the breadcrumb can take it back there.
  const [searchParams] = useSearchParams();
  const dateFromParam = searchParams.get("date_from");
  const dateToParam = searchParams.get("date_to");
  const dateSearch = useMemo(() => {
    const { from, to } = resolveDateRangeParams(dateFromParam, dateToParam);
    return buildDateRangeSearch(from, to);
  }, [dateFromParam, dateToParam]);

  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Link to={`/e-tax${dateSearch}`} style={{ textDecoration: "none", color: "inherit" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {getEtaxBreadcrumbLabel()}
          </Typography>
        </Link>
        <Typography variant="body1" sx={{ mx: 1 }}>
          /
        </Typography>
        <Typography variant="body1" color="primary">
          รอบส่งอัตโนมัติ
        </Typography>
      </Box>

      <AutoSendRounds />
    </Box>
  );
}
